var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__tour"},[_c('div',{staticClass:"container"},[_c('v-tour',{ref:"vtour",attrs:{"name":"myTour","steps":_vm.steps,"options":{
                highlight: true
            },"callbacks":_vm.myCallbacks}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }